module.exports = __webpack_public_path__ + "static/media/gallery9.ba424988.jpg";